import { NgModule } from '@angular/core'
import { NoPreloading, RouterModule, Routes } from '@angular/router'

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'kiosk',
    loadChildren: () => import('./pages/kiosk/kiosk.module').then((m) => m.KioskPageModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then((m) => m.HomePageModule)
  },
  {
    path: 'checkin',
    loadChildren: () => import('./pages/checkin/checkin.module').then((m) => m.CheckinPageModule)
  },
  {
    path: 'waiting',
    loadChildren: () => import('./pages/waiting/waiting.module').then((m) => m.WaitingPageModule)
  },
  {
    path: 'calling',
    loadChildren: () => import('./pages/calling/calling.module').then((m) => m.CallingPageModule)
  },
  {
    path: 'serving',
    loadChildren: () => import('./pages/serving/serving.module').then((m) => m.ServingPageModule)
  },
  {
    path: 'qrcode',
    loadChildren: () => import('./pages/qrcode/qrcode.module').then((m) => m.QrcodePageModule)
  },
  {
    path: 'privacy-policy',
    loadChildren: () => import('./pages/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyPageModule)
  },
  {
    path: 'multiple-waiting',
    loadChildren: () => import('./pages/multiple-waiting/multiple-waiting.module').then(m => m.MultipleWaitingPageModule)
  },
  {
    path: 'site/:site_id/multiple-waiting',
    loadChildren: () => import('./pages/multiple-waiting/multiple-waiting.module').then(m => m.MultipleWaitingPageModule)
  },
  {
    path: 'startup',
    loadChildren: () => import('./pages/startup/startup.module').then(m => m.StartupPageModule)
  },
  {
    path: 'consent',
    loadChildren: () => import('./pages/consent/consent.module').then(m => m.ConsentPageModule)
  },
  {
    path: 'success',
    loadChildren: () => import('./pages/success/success.module').then(m => m.SuccessPageModule)
  },
  {
    path: 'csat',
    loadChildren: () => import('./pages/csat/csat.module').then(m => m.CsatPageModule)
  },
  {
    path: 'calendar/:token',
    loadChildren: () => import('./pages/calendar/calendar.module').then(m => m.CalendarPageModule)
  },
  {
    path: 'self-service',
    loadChildren: () => import('./pages/self-service/self-service.module').then(m => m.SelfServicePageModule)
  },
  {
    path: 'out-off-service',
    loadChildren: () => import('./pages/out-off-service/out-off-service.module').then(m => m.OutOffServicePageModule)
  },
  {
    path: 'booking-schedules',
    loadChildren: () => import('./pages/booking-schedules/booking-schedules.module').then(m => m.BookingSchedulesPageModule)
  },
  {
    path: 'booking-agents',
    loadChildren: () => import('./pages/booking-agents/booking-agents.module').then(m => m.BookingAgentsPageModule)
  },
  {
    path: 'booking-groups',
    loadChildren: () => import('./pages/booking-groups/booking-groups.module').then(m => m.BookingGroupsPageModule)
  },
  {
    path: 'booking-available',
    loadChildren: () => import('./pages/booking-available/booking-available.module').then(m => m.BookingAvailablePageModule)
  },
  {
    path: 'booking-calendar',
    loadChildren: () => import('./pages/booking-calendar/booking-calendar.module').then(m => m.BookingCalendarPageModule)
  },
  {
    path: 'booking-checkout',
    loadChildren: () => import('./pages/booking-checkout/booking-checkout.module').then(m => m.BookingCheckoutPageModule)
  },
  {
    path: 'booking-conditions',
    loadChildren: () => import('./pages/booking-conditions/booking-conditions.module').then(m => m.BookingConditionsPageModule)
  },
  {
    path: 'booking-registration',
    loadChildren: () => import('./pages/booking-registration/booking-registration.module').then(m => m.BookingRegistrationPageModule)
  },
  {
    path: 'booking-pending',
    loadChildren: () => import('./pages/booking-pending/booking-pending.module').then(m => m.BookingPendingPageModule)
  },
  {
    path: 'booking-confirmed',
    loadChildren: () => import('./pages/booking-confirmed/booking-confirmed.module').then(m => m.BookingConfirmedPageModule)
  },
  {
    path: 'booking-cancel/:jwt',
    loadChildren: () => import('./pages/booking-cancel/booking-cancel.module').then(m => m.BookingCancelPageModule)
  },
  {
    path: 'booking-validation/:jwt',
    loadComponent: () => import('./pages/booking-validation/booking-validation.page').then(m => m.BookingValidationPage)
  },
  {
    path: 'booking-confirmation/:jwt',
    loadComponent: () => import('./pages/booking-confirmation/booking-confirmation.page').then(m => m.BookingConfirmationPage)
  },
  {
    path: 'booking-checkin',
    loadChildren: () => import('./pages/booking-checkin/booking-checkin.module').then(m => m.BookingCheckinPageModule)
  },
  {
    path: 'booking-reschedule',
    loadChildren: () => import('./pages/booking-reschedule/booking-reschedule.module').then(m => m.BookingReschedulePageModule)
  },
  {
    path: '**',
    redirectTo: 'home'
  }
]

@NgModule({
  imports: [
  RouterModule.forRoot(routes, { preloadingStrategy: NoPreloading })
  ],
  exports: [RouterModule]
  })
export class AppRoutingModule {}
